const transitionDurations = {
  speedy: 100,
  normal: 200,
  slow: 300,
};

export { transitionDurations };
